import { TAG_MEDIA } from "@/lib/tagMedia";

// THE one media selector for the whole app. Renders from TAG_MEDIA so every print
// location offers the same choices, and a new media added to TAG_MEDIA appears here
// with no per-site edit. `allow` optionally scopes to a subset (e.g. a location label
// that genuinely can't be a 4×6 hang tag); omit it to offer every media.
// `dark` matches the container dialog's dark toolbar.
export function MediaPicker({ value, onChange, allow, dark = false, testidPrefix = "media" }) {
  const options = allow ? TAG_MEDIA.filter((m) => allow.includes(m.code)) : TAG_MEDIA;
  return (
    <div data-testid={`${testidPrefix}-selector`}
      className={`inline-flex rounded-lg overflow-hidden border ${dark ? "border-white/25" : "border-slate-200"}`}>
      {options.map((m, i) => {
        const active = value === m.code;
        const base = "px-3 h-8 text-xs font-semibold transition-colors";
        const edge = i > 0 ? (dark ? "border-l border-white/25" : "border-l border-slate-200") : "";
        const cls = active
          ? (dark ? "bg-white text-[#1F1F1F]" : "bg-[#1F1F1F] text-white")
          : (dark ? "bg-transparent text-slate-300 hover:bg-white/10" : "bg-white text-slate-600 hover:bg-slate-50");
        return (
          <button key={m.code} type="button" data-testid={`${testidPrefix}-${m.code.replace(/_/g, "-")}`}
            onClick={() => onChange(m.code)} className={`${base} ${edge} ${cls}`}>
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
